export const getCompositeAnswerId = (question_id: number, answerable_id: number): string => {
  return `${question_id}-${answerable_id}`;
};
